import codes from '@/codes';
import { Switch as cSwitch } from '@coreui/vue';

//restful api
import { userWsfinder as wsfinder } from '@/service/api/wsfinder'

export default {
  components: {
    cSwitch,
  },
  data : () => { return { codes:codes, confirm: false, add: false, lock: true, model : {} } },
  methods: {
    list() { this.$router.push({ name: 'wsfinder_upattern'}); },
    edit() { this.$router.replace({ name: 'wsfinder_upattern', params: { id: this.model.id, tag: 'edit' }}); },
    async remove() {
      try{
        let rs = await wsfinder.deleteUser({ id : this.model.id})
        if(!rs.error) {
          this.$toastr.s('removed.', this.$route.name);
        } else {
          this.$toastr.e('delete', "failed");
        }
        this.$emit('refresh'); this.list();
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    },
    async get(id = this.$route.params.id) {
      console.log('pattern.detail.vue', 'load item', id);
      try {
        let rs = await wsfinder.detailUser({ id : id})
        this.model = Object.assign({}, this.model, rs.body)
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    }
  },
  watch: { '$route' (to, from) { this.get(to.params.id); console.log(`from : ${from}`); } },
  created: function() { console.log('pattern.detail.vue', 'created'); },
  destroyed: function() { console.log('pattern.detail.vue', 'destroyed'); },
  mounted: function() {
    console.log('pattern.detail.vue', 'mounted');
    this.get(this.$route.params.id);
  },
}